import React, { Component } from 'react'
import LoggedContext from '../BusinessObjects/LoggedContext'
import cubeApiClient from '../BusinessObjects/cubeApiService';
import { Container, Row, Col } from 'reactstrap';
import '../index.css';

interface EsaedroObjectDeleteProps {
    myObjType: string;
    myObjUrl: string;
    myObj: any;
    onReturn?(returnMsg?:string): void
}

interface EsaedroObjectDeleteState {
    objToBeDeleted: any;
    errorMessage:string;
}

export default class EsaedroObjectDelete extends Component<EsaedroObjectDeleteProps, EsaedroObjectDeleteState> {
    static contextType = LoggedContext
    context!: React.ContextType<typeof LoggedContext>
    
    constructor(props: any) {
        super(props);

        this.state = {
            objToBeDeleted: '',
            errorMessage:''            
        };
    }

    componentDidMount() {

        this.setState({objToBeDeleted: this.props.myObj});
    
        if(this.context.userProfile == undefined) 
        {
            this.setState({errorMessage:'utente non definito'});
            return;
        }
    
        if(this.context.userProfile.customer_ID == 0) 
        {
            this.setState({errorMessage:'azienda non selezionata'});
            return;
        }
    
    }

    deleteObj = () => {

        const service = new cubeApiClient();
        const t = this.context.tokenAPI;

        service
            .deleteObject([this.state.objToBeDeleted] , this.props.myObjUrl, t)
            .then(() => {
                if (this.props.onReturn!=undefined) {
                    let successMsg = "Operazione avvenuta con successo!"
                    this.props.onReturn(successMsg)
                }
            },
            (error: any) => {
                let stringError = "Errore nella cancellazione: "+JSON.stringify(error)
                this.setState({errorMessage:stringError});;
            });  
    }

    returnToList = () => {
        if (this.props.onReturn!=undefined) {
            this.props.onReturn()
        }
    }

    render() {

        if(this.state.errorMessage!='')
        {
            return (
                <Container>
                    <Row>
                        <Col>
                            <h1 className="deleteHeader">{this.state.errorMessage}</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <button className="btn btn-lg btn-outline-secondary" onClick={this.returnToList}>Indietro</button>
                        </Col>
                    </Row>
                </Container>
            )
        }
        
        return (
            <Container>
                <Row>
                    <Col>
                        <h1 className="deleteHeader">Sei sicuro di voler cancellare questo record?</h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2 className="Id">Record Id: { this.state.objToBeDeleted.Id }</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>{this.state.objToBeDeleted.Description}</h2>                    
                    </Col>
                </Row>
                <Row><Col>&nbsp;</Col></Row>
                <Row>
                    <Col>
                        <button className="btn btn-lg btn-danger" onClick={this.deleteObj}>Si</button>
                    </Col>
                    <Col>
                        <button className="btn btn-lg btn-outline-secondary" onClick={this.returnToList}>No</button>
                    </Col>
                </Row>
        </Container>
        )
    }
}
